import { useCallback, useEffect, useState } from 'react';

const LAST_EMAIL_KEY = 'LAST_EMAIL';
export const EMAIL_REGEX = /^[\w.+%-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

const isValidEmail = (value: string) => EMAIL_REGEX.test(value);

// Make the last email available in localStorage
const useLastEmail = () => {
    const [lastEmail, setLastEmail] = useState<string | null>(null);

    const updateLastEmail = useCallback((email: string | undefined) => {
        if (email && isValidEmail(email)) {
            localStorage.setItem(LAST_EMAIL_KEY, email);
        }
    }, []);

    useEffect(() => {
        const record = localStorage.getItem(LAST_EMAIL_KEY);

        if (record && isValidEmail(record)) {
            setLastEmail(record);
        }
    }, []);

    return {
        lastEmail,
        updateLastEmail,
    };
};

export default useLastEmail;
